const storeLocator = require('../storeLocator/storeSelector');
const validation = require('../components/clientSideValidation');
const waiNotify = require('../components/waiNotify');

const storeSelectors = {
    storeContainer: '.js-instore-pickup',
    storeResults: '.js-store-card-results',
    storeResultsContainer: '.js-nearest-store-results',
    selectedStore: '.js-selected-store-with-inventory',
    selectedStoreTitle: '.js-selected_store_title',
    selectedStoreBody: '.js-selected-card-body',
    contactStoreError: '.js-contactstore-error',
    emptyStoreError: '.js-emptystore-error',
    preferredStoreError: '.js-preferred-store-error',
    contactStoreInStock: '.js-contactstore-instock'
};

const $storeContainer = $(storeSelectors.storeContainer);
const notifications = {
    selected: $storeContainer.data('action-message-store-selected'),
    removed: $storeContainer.data('action-message-store-removed'),
    changed: $storeContainer.data('action-message-store-changed')
};

/**
 * init popup for close confirmation
 */
function initConfirmationClosePopup() {
    $(document.body).on('click.closeConfimation', (e) => {
        const $target = $(e.target);
        const $modal = $target.closest('.js-store-inventory-modal');
        const $modalContent = $target.closest('.js-store-inventory-modal-content');

        if ($modal.length && ($target.closest('.js-modal-close-btn').length || !$modalContent.length)) {
            window.dialogManager.closeAll();
        }

        if ($target.closest('.js-close-confirm-select').length) {
            window.dialogManager.closeAll();

            const $selectBtn = $('.js-store-inventory-modal').find('.js-select-store');

            if ($selectBtn.length && $selectBtn.hasClass('js-store-has-been-selected') && !$('.js-selected-store-with-inventory').length) {
                $selectBtn.trigger('click');
            }

            $(document.body).off('click.closeConfimation');
        }

        if ($target.closest('.js-cancel-close').length) {
            window.dialogManager.closeDialog();
        }
    });
}


/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('.js-store-inventory-modal').length !== 0) {
        $('.js-store-inventory-modal, .js-confirm-close-popup').remove();
    }

    const htmlTemplate = $('#isp-modal-template').html();

    $('.b-page_inner').append(htmlTemplate);
    window.dialogManager.openDialog('panel', '#inStoreInventoryModal', $('.js-btn-get-in-store-inventory')[0]);
    initConfirmationClosePopup();
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElement(pid, quantity, selectedPostalCode, selectedRadius) {
    const requestData = {
        products: `${pid}:${quantity}`
    };

    if (selectedRadius) {
        requestData.radius = selectedRadius;
    }

    if (selectedPostalCode) {
        requestData.postalCode = selectedPostalCode;
    }

    $('.js-store-inventory-body')
        .attr('aria-busy', true)
        .addClass('m-animated')
        .spinner().start(true);

    $.ajax({
        url: $('.js-btn-get-in-store-inventory').data('action-url'),
        data: requestData,
        method: 'GET',
        success: (response) => {
            $('.js-store-inventory-body').empty()
                .attr('aria-busy', false)
                .removeClass('m-animated')
                .spinner().stop();
            $('.js-store-inventory-body').html(response.storesResultsHtml);
            validation.init();
            storeLocator.search();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();
            storeLocator.expandStoresEvent('#inStoreInventoryModal');

            $('.btn-storelocator-search').attr('data-search-pid', pid);

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();
            }
        },
        error: () => {}
    });
}

function isProductAvailable() {
    return $('.js-product-availability')
        .toArray().every(item => $(item).data('available') && $(item).data('ready-to-order'));
}

/**
 * Remove the selected store.
 */
function deselectStore() {
    const $storeElement = $(storeSelectors.selectedStore);
    const $storeElementTitle = $(storeSelectors.selectedStoreTitle);
    $storeElement.find(storeSelectors.selectedStoreBody).empty();
    $storeElement.data('store-id', '');
    $storeElement.addClass('h-hidden');
    $storeElementTitle.addClass('h-hidden');
    $('.js-btn-get-in-store-inventory').show();
}

/**
 * Update quantity options. Only display quantity options that are available for the store.
 * @param {string} searchPID - The product ID of the selected product.
 * @param {number} storeId - The store ID selected for in store pickup.
 */
function updateQuantityOptions(searchPID, storeId) {
    const $productContainer = $(`.js-product-detail[data-pid='${searchPID}']`);
    const $quantitySelector = $productContainer.find('.js-quantity-select');
    const requestData = {
        pid: $productContainer.data('pid'),
        quantitySelected: $quantitySelector.val(),
        storeId
    };

    $.ajax({
        url: $('.js-btn-get-in-store-inventory').data('ats-action-url'),
        data: requestData,
        method: 'GET',
        success: (response) => {
            let atsValue = response.atsValue;

            if (('ats' in response) && response.ats.homeDelivery && (!atsValue || (atsValue < response.ats.homeDelivery))) {
                atsValue = response.ats.homeDelivery;
            }

            // Set max quantity from inventory value
            if ( atsValue && parseInt($quantitySelector.attr('aria-valuemax')) > atsValue) {
                $quantitySelector.attr('aria-valuemax', atsValue);
            }

            if ($quantitySelector.length) {
                $quantitySelector[0].spinbutton.update();
            }

            const $stickyQuantitySelector = $('.js-sticky-quantity');

            $stickyQuantitySelector.attr('aria-valuemax', atsValue || 1);
            if ($stickyQuantitySelector.length) {
                $stickyQuantitySelector[0].spinbutton.update();
            }
        }
    });
}

function isSmallViewPort() {
    return window.innerWidth < window.styleConstants.breakpoint.small;
}

$(document).on('change', '.js-door-dash-postal-code', ()=>{
    let trimValue = $('.js-door-dash-postal-code').val().trim();
    $('.js-door-dash-postal-code').val(trimValue);
});

module.exports = {
    removeSelectedStoreOnAttributeChange: () => {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            response.container.attr('data-pid', response.data.product.id);
        });
    },
    updateAddToCartFormData: () => {
        $('body').on('updateAddToCartFormData', (e, form) => {
            const $storeElement = $('.js-selected-store-with-inventory');
            if (form.pidsObj) {
                const pidsObj = JSON.parse(form.pidsObj);
                pidsObj.forEach((product) => {
                    product.storeId = $storeElement ? $storeElement.attr('data-store-id') : null;
                });

                form.pidsObj = JSON.stringify(pidsObj);
            }
            if ($(e.target).hasClass('js-door-dash')) {
                form.storeId = $(e.target).attr('data-store-number');
                form.zipCode = $(e.target).attr('data-zip-code');
            } else if ($(e.target).hasClass('js-ISPU')) {
                form.storeId = $storeElement.attr('data-store-id');
            } else {
                form.storeId = null;
            }
        });
    },

    showInStoreInventory: () => {
        $('.js-btn-get-in-store-inventory').on('click', (e) => {
            const $productDetailsElement = $(e.currentTarget).closest('.js-product-detail');
            const pid = $productDetailsElement.attr('data-pid');
            const quantity = $productDetailsElement.find('.js-quantity-select').val();
            getModalHtmlElement();
            fillModalElement(pid, quantity);
            e.stopPropagation();
        });
    },
    showZipCodeBlock: () => {
        $('body').on('click', '.js-btn-get-door-dash-inventory', () => {
            $('.js-zip-code-block').toggleClass('h-hidden');
        });
    },
    zipCodeValidation: () => {
        $('body').on('submit', '.js-door-dash-form', (e) => {
            e.preventDefault();
            $('.js-door-dash-error').hide();
            let spinner = $(e.target).spinner();
            let doorDashForm = $('.js-door-dash-form');
            let url = doorDashForm.data('action-url');
            let zip = doorDashForm.find('.js-door-dash-postal-code').val();
            let storeId = doorDashForm.data('store-id');
            let productId = $('.js-door-dash').data('pid');
            const doorDashButton = $('.js-door-dash');
            doorDashButton.prop('disabled', true);
            spinner.start();

            let storeObject = {
                postalcode: zip,
                storeNumber: storeId,
                productId: productId
            };

            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                data: storeObject,
                success(data) {
                    if (data.isValidStore) {
                        doorDashButton.attr('data-store-number', storeId);
                        doorDashButton.attr('data-zip-code', zip);
                        doorDashButton.prop('disabled', false);
                        $('.js-zip-code-block').toggleClass('h-hidden');
                        spinner.stop();
                    } else {
                        $('.js-door-dash-error').show();
                        spinner.stop();
                    }
                }
            });
        });
    },
    removeStoreSelection: () => {
        $('body').on('click', '#remove-store-selection', ((e) => {
            deselectStore();
            $('.js-select-current-store').prop('disabled', false);
            $('.js-quantity-select').addClass('m-disabled').prop('disabled', true);
            $(e.target).closest(storeSelectors.selectedStore).addClass('h-hidden');
            $(storeSelectors.selectedStoreTitle).addClass('h-hidden');
            $(storeSelectors.storeResultsContainer).removeClass('h-hidden');
            if (!($('.js-homeDelivery').hasClass('m-available') && isProductAvailable())) {
                // Show Empty Store error
                $(storeSelectors.emptyStoreError).removeClass('h-hidden');
                $('body').trigger('store:cleared');
            }
            $('body').trigger('product:updateAddToCart');
            waiNotify(notifications.removed);
        }));
    },
    selectStoreWithInventory: () => {
        $('body').on('store:selected', (e, data) => {
            const searchPID = $('.js-btn-get-in-store-inventory').data('search-pid');
            const $storeElement = $(storeSelectors.selectedStore);
            const $storeElementBody = $storeElement.children(storeSelectors.selectedStoreBody);
            const $isAvailableInPreferredStore = $('.js-shipping-info').data('availabilityinpreferredstore');
            const isAvailableForInStorePickup = $('.js-shipping-info').data('availableforinstorepickup');
            const isComingSoon = $('.js-shipping-info').data('comingsoon');
            const isComingSoonAvailable = $('.js-shipping-info').data('comingsoonavailable');
            // Hide Empty Store and Contact Store errors
            $(storeSelectors.emptyStoreError).addClass('h-hidden');
            $(storeSelectors.contactStoreError).addClass('h-hidden');
            $(storeSelectors.preferredStoreError).addClass('h-hidden');
            // Hide Nearest Stores section
            $(storeSelectors.storeResultsContainer).addClass('h-hidden');
            $storeElementBody.empty().append(data.storeDetailsHtml);
            $storeElement.attr('data-store-id', data.storeID);
            $storeElement.removeClass('display-none');
            $(storeSelectors.selectedStore + ' ' + storeSelectors.selectedStoreBody + ' .row .js-select-button').remove();
            $storeElement.removeClass('h-hidden');
            $(storeSelectors.selectedStore).removeClass('h-hidden');
            $(storeSelectors.selectedStoreTitle).removeClass('h-hidden');
            $('.js-select-current-store').prop('disabled', true);
            if (data.preferredStoreEvent) {
                if ($isAvailableInPreferredStore && isAvailableForInStorePickup && !(isComingSoon && !isComingSoonAvailable)) {
                    if ($('.js-ISPU').hasClass('m-disabled')) {
                        $('.js-ISPU').removeClass('m-disabled');
                    }
                    if ($('.js-footerISPU').hasClass('m-disabled')) {
                        $('.js-footerISPU').removeClass('m-disabled');
                    }
                    // Check if there is inventory in preferred store, then show in stock msg.
                    if ($(storeSelectors.contactStoreInStock).length) {
                        let preferredStoreAvailable = $(storeSelectors.contactStoreInStock).text().replace('#', data.name);
                        $(storeSelectors.contactStoreInStock).text(preferredStoreAvailable);
                        $(storeSelectors.contactStoreInStock).removeClass('h-hidden');
                    }
                } else if (!$isAvailableInPreferredStore && data.storeID && isAvailableForInStorePickup) {
                    let preferredStoreError = $('.js-preferred-store').text().replace('#', data.name);
                    $('.js-preferred-store').text(preferredStoreError);
                    if (!$('.js-ISPU').hasClass('m-disabled')) {
                        $('.js-ISPU').addClass('m-disabled');
                    }
                    if (!$('.js-footerISPU').hasClass('m-disabled')) {
                        $('.js-footerISPU').addClass('m-disabled');
                    }
                    if (!$(storeSelectors.contactStoreError).hasClass('h-hidden')) {
                        $(storeSelectors.contactStoreError).addClass('h-hidden');
                    }
                    if ($(storeSelectors.preferredStoreError).hasClass('h-hidden')) {
                        $(storeSelectors.preferredStoreError).removeClass('h-hidden');
                    }
                    if ($(storeSelectors.contactStoreInStock).length) {
                        $(storeSelectors.contactStoreInStock).addClass('h-hidden');
                    }
                } else if (!isAvailableForInStorePickup) {
                    let itemNotInStore = $(storeSelectors.contactStoreError).text().replace('#', data.name);
                    $(storeSelectors.contactStoreError).text(itemNotInStore);
                    if (!$('.js-ISPU').hasClass('m-disabled')) {
                        $('.js-ISPU').addClass('m-disabled');
                    }
                    if (!$('.js-footerISPU').hasClass('m-disabled')) {
                        $('.js-footerISPU').addClass('m-disabled');
                    }
                    if (!$(storeSelectors.preferredStoreError).hasClass('h-hidden')) {
                        $(storeSelectors.preferredStoreError).addClass('h-hidden');
                    }
                    if ($(storeSelectors.contactStoreError).hasClass('h-hidden')) {
                        $(storeSelectors.contactStoreError).removeClass('h-hidden');
                    }
                    if ($(storeSelectors.contactStoreInStock).length) {
                        $(storeSelectors.contactStoreInStock).addClass('h-hidden');
                    }
                }
            } else if (data.storeID && !(isComingSoon && !isComingSoonAvailable)) {
                if ($('.js-ISPU').hasClass('m-disabled')) {
                    $('.js-ISPU').removeClass('m-disabled');
                }
                if ($('.js-footerISPU').hasClass('m-disabled')) {
                    $('.js-footerISPU').removeClass('m-disabled');
                }
                if ($(storeSelectors.contactStoreInStock).length) {
                    let preferredStoreAvailable = $(storeSelectors.contactStoreInStock).attr('data-msg').replace('#', data.name);
                    $(storeSelectors.contactStoreInStock).text(preferredStoreAvailable);
                    $(storeSelectors.contactStoreInStock).removeClass('h-hidden');
                }
            }
            $('.js-quantity-select').hasClass('m-disabled') ? $('.js-quantity-select').removeClass('m-disabled') : '';
            $('.js-increment').hasClass('m-disabled') ? $('.js-increment').removeClass('m-disabled') : '';

            updateQuantityOptions(searchPID, data.storeID);

            window.dialogManager.closeDialog();
            $('#inStoreInventoryModal, #confirmCloseStoreSelect').remove();
            $(document.body).off('click.closeConfimation');
            $('.js-selected-store').text(data.name);
            $('.js-door-dash-form').data('store-id', data.storeID);
            if (isComingSoon && !isComingSoonAvailable) {
                $('.js-btn-get-door-dash-inventory').hide();
            }
            if (!data.showNotify) {
                waiNotify(notifications.selected);
            }
        });
    },
    changeStore: () => {
        $('body').on('click', '.change-store', (e) => {
            const $changeStoreElement = $(e.currentTarget);
            const $productDetailsElement = $changeStoreElement.closest('.js-product-detail');
            const pid = $productDetailsElement.attr('data-pid');
            const quantity = $productDetailsElement.find('.quantity-select').val();
            const postalCode = $changeStoreElement.data('postal');
            const radius = $changeStoreElement.data('radius');
            getModalHtmlElement();
            fillModalElement(pid, quantity, postalCode, radius);
        });
    },
    selectCurrentStore: () => {
        $('body').on('click', '.js-select-current-store', ((e) => {
            //Select the store in Nearest Stores on PDP
            e.preventDefault();
            var selectedStore = e.target.closest('.store-details');
            var data = {
                storeID: $(selectedStore).data('store-id'),
                storeDetailsHtml: $(selectedStore).html(),
                event: e
            };
            $('body').trigger('store:selected', data);
        }));
    },
    displayHours() {
        storeLocator.displayHours();
    },
    selectHomeStoreInPDP() {
        var myHomeStoreData = $('.js-selected-my-home-store').data('store-info');
        if (myHomeStoreData) {
            var data = {
                storeID: myHomeStoreData.ID,
                name: myHomeStoreData.name,
                preferredStoreEvent: true,
                showNotify: true
            };
            $('body').trigger('store:selected', data);
        }
    },
    updateStores: () => {
        $('body').on('product:updateInStorePickup', (e, product) =>{
            var $storeContainer = $(storeSelectors.storeContainer);
            var $storeResultsElement = $(storeSelectors.storeResults);
            $storeContainer.attr('data-pid', product.id);
            deselectStore();
            if (product.isVariationSelected && (product.availableForInStorePickup || product.availableInStores)) {
                $storeResultsElement.empty();
                $storeResultsElement.html(product.storesHTML);
            } else {
                $storeResultsElement.empty();
                $storeContainer.addClass('h-hidden');
            }
        });
    }
};
